import { Store } from '@tanstack/store';

export const PublicMessageToChatStore = new Store<{ message: string | null }>({ message: null });
